export const GetDashboard_Url = "/dashboardms/get";
export const AddContactsToGroup_Url = "/smsGroupContactms/addContactsToGroup";
export const CheckExistingEmail_Url = "/regms/checkRegistration";
export const CheckDpTextExistingEmail_Url = "/dpRegms/checkRegistration";
export const CheckTollFreePurchaseVerificationStatus_Url =
  "/twilioms/checkTollfreePurchaseVerificationStatus";
export const ContactList_Url = "/smscontactms/getList";
export const CreateGroupContact_Url = "/smsGroupContactms/createGroupContact";
export const CreateGroup_Url = "/smsgroupms/create";
export const CreateMessage_Url = "/smsmessagems/create";
export const CreateShort_URL = "/su/shorten";
export const CreateUser_Url = "/appuserms/create";
export const DeleteContactFromGroup_Url =
  "/smsGroupContactms/deleteContactFromGroup";
export const DeleteContact_Url = "/smscontactms/delete";
export const DeleteContactsFromGroup_Url =
  "/smsGroupContactms/deleteContactsFromGroup";
export const DeleteGroup_Url = "/smsgroupms/delete";
export const DeleteMessage_Url = "/smsmessagems/delete";
export const DeleteTollFreeNumber_Url = "twilioNumberms/delete";
export const DeleteUser_Url = "/appuserms/delete";
export const ExportSmsContacts_Url = "/csvImpExpms/exportSmsContacts";
export const ExportGroupContacts_Url = "/csvImpExpms/exportGroupContacts";
export const FindByNumber_Url = "/smscontactms/findByNumber";
export const ForgetPassword_Url = "/appuserms/forgetPassword";
export const GetBilling_Url = "/billingms/get";
export const GetCampaigningInfo_Url = "/campaigningInfoms/get";
export const GetContact_Url = "/smscontactms/get";
export const GetCountryList_Url = "/countryms/get";
export const GetCrmIntegration_Url = "/integrationms/get";
export const GetGroup_Url = "/smsgroupms/get";
export const GetMessage_Url = "/smsmessagems/get";
export const GetForTestAndSend_Url = "/smsmessagems/getForTestAndSend";
export const GetPlanCategory_Url = "/planCategoryms/get";
export const GetProfile_Url = "/appuserms/getProfile";
export const deleteAccount_Url = "/organizationms/deleteAccount";
export const GetTollFreeNumbers_Url = "/twilioms/getTollfreeNumbers";
export const GetUser_Url = "/appuserms/get";
export const GetWidget_Url = "/smsmessagems/getWidget";
export const GroupList_Url = "/smsgroupms/getList";
export const AllGroupList_Url = "/smsgroupms/getAllGroups";
export const GetGroupActivityList_Url = "/quickTextms/getGroupActivityList";
export const ImportContacts_Url = "/csvImpExpms/importContacts";
export const GetTokenData_Url = "/staticms/getTokenData";
export const LogOut_Url = "/appuserms/logout";
export const Login_Url = "/appuserms/login";
export const RmLogin_Url = "/appuserms/rmlogin";
export const RmGmailLogin_Url = "/appuserms/rmGmailLogin";
export const LOGIN_WITH_GMAIL = "/appuserms/gmailLogin";
export const MessageList_Url = "/smsmessagems/getList";
export const GetMMSImage_Url = "/smsmessagems/getImage";
export const MessageTemplateList_Url = "/organizationms/getMessageTemplates";
export const PostVerifyAccount_Url = "/regms/postVerify";
export const ProfileList_Url = "/profilems/getList";
export const PurchaseTollFreeNumber_Url = "/twilioms/purchaseTollfreeNumber";
export const AddTollFreeNumber_Url = "/twilioms/addTollfreeNumber";
export const Registration_Url = "/regms/create";
export const ResendVerificationCode_Url = "/regms/resendVerificationCode";
export const ResetPassword_Url = "/appuserms/resetPassword";
export const SendWidgetMsgToPhone_Url = "/twilioms/sendWidgetMsg";
export const AccountSettings_Url = "/accountms/getSettings";
export const Static_Url = "/staticms/get";
export const StaticEventText_Url = "/staticms/getForEventText";
export const StaticDPText_Url = "/staticms/getForDPText";
export const getCrmStatic_Url = "/blackbaudcrmms/getStaticData";
export const SendQuickText_Url = "/qwikTextms/sendQuickText";
export const SendTestQuickText_Url = "/quickTextms/sendTestQuickText";
export const SendQuickTextToGroupActivity_Url =
  "/quickTextms/sendQuickTextToGroupActivity";
export const SendSmsQuickText_Url = "/quickTextms/sendTestMessage";
export const SendSmsToGrops_Url = "/twilioms/sendSms";
export const MessageLogList_Url = "/messageLogms/getList";
export const sendMessageToNotReplied_Url = "/twilioms/sendToNotReplied";
export const TenantList_Url = "/tntms/getList";
export const TwilioNumberList_Url = "/twilioNumberms/getList";
export const UpdateBilling_Url = "/billingms/update";
export const UpdateCampaigningInfo_Url = "/campaigningInfoms/update";
export const UpdateContact_Url = "/smscontactms/update";
export const UpdateCrmIntegration_Url = "/integrationms/updateCrm";
export const UpdateGroup_Url = "/smsgroupms/update";
export const UpdateMMS_Url = "/mmsms/uploadMms";
export const UpdateMessage_Url = "/smsmessagems/update";
export const UpdateProfile_Url = "/appuserms/updateProfile";
export const UpdateUser_Url = "/appuserms/update";
export const UpdateWidget_Url = "/smsmessagems/updateWidget";
export const UploadCampaigningInfoFile_Url = "/campaigningInfoms/uploadFile";
export const UploadTaxExcDoc_Url = "/regms/uploadTaxExcemptDoc";
export const UserList_Url = "/appuserms/getList";
export const VerifyAccount_Url = "/regms/verify";
export const GetGroupList_Url = "/smscontactms/getGroupList";
export const getListWithAllActives = "/smsgroupms/getListWithAllActives";
export const BusinessTypeList_Url = "/businessTypems/getList";
export const BusinessUsecaseList_Url = "/useCasems/getForBusinessType";
export const ActiveForBusinessType_Url = "/useCasems/getActiveForBusinessType";
export const SmsActivityList_Url = "/activityMs/getList";
export const GetMessageActivityContacts_Url = "/messageLogms/getSmsLogHistory";
export const MessageLogDelete_Url = "/messageLogms/delete";
export const cancelScheduledSend_Url = "/messageLogms/cancelScheduling";
export const MessageLogDeleteMultiple_Url = "/messageLogms/deleteMultiple";
export const ActivityContactList_Url = "/activityMs/getContacts";
export const SendSimulatedReponseMessage_Url =
  "/messageLogms/sendSimulatedReponseMessage";
export const GetConversation_Url = "/smsLogms/getConversation";
export const ScheduledSMS_Url = "/twilioms/scheduleSms";
export const ScheduledSendList_Url = "/messageLogms/getScheduledList";
export const UpdateSchedulingDate_Url = "/messageLogms/updateScheduling";
export const GroupsAndActivitiesLogList_Url =
  "/messageLogms/getGroupsAndActivities";
export const GroupLogList_Url = "/messageLogms/getGroups";
export const ActivityLogList_Url = "/messageLogms/getMsgLogActivities";
export const getMsgShortLinks_Url = "/su/getMsgShortLinks";
export const ShortLinkList_Url = "/su/getList";
export const DeleteShortLink_Url = "/su/delete";
export const GetQRCode_Url = "/smsmessagems/getQRCode";
export const PledgeStaticData_Url = "/pledgems/getStaticData";
export const PledgeGetForMessage_Url = "/pledgems/getForMessage";
export const PledgeUpdated_Url = "/pledgems/update";
export const PledgeDonationAdd_Url = "/pledgeDonationms/add";
export const PledgeDonationGet_Url = "/pledgeDonationms/get";
export const PledgeDonationUpdate_Url = "/pledgeDonationms/update";
export const PledgeDonationDelete_Url = "/pledgeDonationms/delete";
export const ImportDonations_Url = "/csvImpExpms/importDonations";
export const ExportDonations_Url = "/csvImpExpms/exportDonations";
export const PledgeThermometer_Url = "/pledgems/pledge";
export const neonCrmIntegration_Url = "/neoncrmms/checkConnection";
export const neonCrmSyncContacts_Url = "/neoncrmms/syncContacts";
export const blackbaudCrmSyncContacts_Url =
  "/blackbaudcrmms/syncContactsFromBlackbaud";
export const ResentOTP_Url = "/appuserms/resendOtp";
export const EventList_Url = "/eventms/getList";
export const ImportEvents_Url = "/excelImpExpms/importEvents";

//DP Text servicess
export const DPTextRegistration_Url = "dpRegms/create";
export const DPTextPostVerify_Url = "/dpRegms/postVerify";
export const DPTextTenantList_Url = "/tntms/getDPTextList";
export const DPTextLogin_Url = "/appuserms/dpTextLogin";
export const DPTextGmailLogin_Url = "/appuserms/dptextGmailLogin";
export const DPTextRmLogin_Url = "/appuserms/dpTextRmLogin";
export const DPTextRmGmailLogin_Url = "/appuserms/dptextRmGmailLogin";
export const DPTextForgetPassword_Url = "/appuserms/dpTextForgetPassword";
export const DPTextResetPassword_Url = "/appuserms/dpTextResetPassword";
export const DPTextCrmSyncContacts_Url = "/dptextCrmms/syncDoners";

//Paypal Payment services
export const PaymentSuccess_Url = "/paypalms/paymentSuccess";
export const PaymentCancel_Url = "/paypalms/paymentCancel";

// Admin Panel services //
export const ApLogin_Url = "/apAppuserms/login";
export const ApVerifyOTP_Url = "/apAppuserms/verifyOtp";
export const ApForgetPassword_Url = "/apAppuserms/forgetPassword";
export const ApResetPassword_Url = "/apAppuserms/resetPassword";
export const ApStatic_Url = "/apStaticms/get";
export const ApAppuserGetList_Url = "/apAppuserms/getList";
export const ApAppuserGet_Url = "/apAppuserms/get";
export const ApAppuserCreate_Url = "/apAppuserms/create";
export const ApAppuserUpdate_Url = "/apAppuserms/update";
export const ApAppuserDelete_Url = "/apAppuserms/delete";
export const ApProfileMsGetList_Url = "/apProfilems/getList";
export const ApProfileMsGet_Url = "/apProfilems/get";
export const ApProfileMsCreate_Url = "/apProfilems/create";
export const ApRegistrationList_Url = "/apAccountms/getList";
export const ApGetRegistration_Url = "/apAccountms/get";
export const AccessAccount_Url = "/apAccountms/accessAccount";
export const closeAccount_Url = "/apAccountms/close";
export const ApEnableRegistration_Url = "/apAccountms/enable";
export const ApPauseRegistration_Url = "/apAccountms/pause";
export const ApDeleteRegistration_Url = "/apAccountms/delete";
export const ApUpdateTrainingStatus_Url = "/apAccountms/updateTrainingStatus";
export const ApUpdateTextMessageLength_Url =
  "/apAccountms/updateTextMessageLength";
export const ApEmailTemplateList_Url = "/emailTemplatems/getList";
export const ApGetEmailTemplate_Url = "/emailTemplatems/get";
export const ApUpdateEmailTemplate_Url = "/emailTemplatems/update";
export const ApSendEmailTemplate_Url = "/emailTemplatems/emailTemplate";
export const ApMessageTemplate_Url = "/msgTemplatems/getList";
export const ApGetMessageTemplate_Url = "/msgTemplatems/get";
export const ApCreateMessageTemplate_Url = "/msgTemplatems/create";
export const ApUpdateMessageTemplate_Url = "/msgTemplatems/update";
export const ApDeleteMessageTemplate_Url = "/msgTemplatems/delete";
export const ApLogout_Url = "/apAppuserms/logout";
export const ApResentOTP_Url = "/apAppuserms/resendOtp";
export const ApGetProfile_Url = "/apAppuserms/getProfile";

export const ApDomainList_Url = "/businessDomainms/getList";
export const ApBusinessTypeList_Url =
  "/businessTypems/getListForBusinessDomain";
export const ApCreateBusinessType_Url = "/businessTypems/create";
export const ApUpdateBusinessType_Url = "/businessTypems/update";
export const ApcreateuseCase_Url = "/useCasems/create";
export const ApUseCaseList_Url = "/useCasems/getForBusinessType";

export const ApDeleteUseCase_Url = "/useCasems/delete";
export const ApUpdateUseCase_Url = "/useCasems/update";
export const ApCreatePlan_Url = "/planms/create";
export const ApDeleteBusinessType_Url = "/businessTypems/delete";
export const ApGetUseCase_Url = "/useCasems/get";
export const ApGetPlanList_Url = "/planms/getForBusinessUseCase";
export const ApUpdatePlan_Url = "/planms/update";
export const ApDeletePlan_Url = "/planms/delete";
export const ApSendToCustomer_Url = "/customPlanms/sendToCustomer";
